import { PFX } from './constant.js'

// 分公司高级弹窗配置参数
export const companyAdvanceConfig = {
    name: '分公司',
    value: 'companyName',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'companyNameCn', value: '分公司名称' },
        { prop: 'companyCode', value: '分公司编码' },
    ],
    tableConfig: [
        { prop: 'companyCode', value: '分公司编码' },
        { prop: 'companyNameCn', value: '分公司名称' },
    ],
    advanceUrl: '/esCompany/popCompany',
    cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
}

// 服务平台
export const siteAdvanceConfig = {
    name: '服务平台',
    value: 'siteName',
    type: 'advance',
    unfold: false,
    advanceConfig: [
        { prop: 'escoCompanyNameCn', value: '服务平台名称' },
        { prop: 'escoCompanyNo', value: '服务平台编码' },
    ],
    tableConfig: [
        { prop: 'escoCompanyNameCn', value: '服务平台名称' },
        { prop: 'escoCompanyNo', value: '服务平台编码' },
    ],
    advanceUrl: '/searchPlatform',
    cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
    advanceCascade: 'companyCode#companyCode',
}

// 会计主体
export const accountAdvanceConfig = {
    name: '会计主体',
    value: 'ledgerName',
    advanceLabel: '会计主体',
    type: 'advance',
    advanceConfig: [
        { prop: 'operatingUnitName', value: '会计主体名称' },
        { prop: 'operatingUnitId', value: '会计主体编码' },
    ],
    tableConfig: [
        { prop: 'operatingUnitId', value: '会计主体编码' },
        { prop: 'operatingUnitName', value: '会计主体名称' },
    ],
    cbParams: ['operatingUnitName#ledgerName', 'operatingUnitId#ledgerCode'],
    advanceUrl: '/supplier/queryEfOrganRelationPage',
    prefix: 'api-srm-web',
}

// 保险公司
export const insrCompanyAdvanceConfig = {
    name: '保险公司',
    value: 'baSupplersName',
    advanceLabel: '保险公司',
    type: 'advance',
    advanceConfig: [
        { prop: 'supplierNameCn', value: '公司名称' },
        { prop: 'supplierCode', value: '公司编码' },
    ],
    tableConfig: [
        { prop: 'supplierCode', value: '公司编码' },
        { prop: 'supplierNameCn', value: '公司名称' },
    ],
    cbParams: ['supplierNameCn#baSupplersName', 'supplierCode#baSupplersCode', 'paymentTerms#baPaymentterms'],
    advanceUrl: '/supplier/supplierInfos',
    prefix: 'api-srm-web',
    method: 'post',
    advanceCascade: 'supplierStatusList',
}

// 银行账号
export const bankAdvanceConfig = {
    name: '银行账号',
    value: 'bankAccount',
    advanceLabel: '银行账号',
    type: 'advance',
    advanceConfig: [
        { prop: 'bankName', value: '开户银行' },
        { prop: 'bankAccount', value: '银行账号' },
    ],
    tableConfig: [
        { prop: 'bankAccount', value: '银行账号' },
        { prop: 'bankName', value: '开户银行' },
    ],
    cbParams: ['bankAccount', 'bankAccountName', 'bankName', 'accountCurrency', 'ubankNo'],
    advanceUrl: '/supplier/supplierFinanceInfos',
    prefix: 'api-srm-web',
    method: 'post',
    advanceCascade: 'accountFlag,supplierCode',
}

// 币种
export const currencyAdvanceConfig = {
    name: '币种',
    value: 'currency',
    advanceConfig: [
        { prop: 'nameCn', value: '币种名称' },
        { prop: 'currency', value: '币种代码' },
    ],
    advanceUrl: '/efCurrency/search',
    cbParams: ['currency', 'nameCn'],
    tableConfig: [
        { prop: 'currency', value: '币种代码' },
        { prop: 'nameCn', value: '币种名称' },
    ],
}

// 税率
export const taxRateAdvanceConfig = {
    name: '税率',
    value: 'taxRate',
    type: 'advance',
    advanceConfig: [
        // { prop: 'ALL', value: '全部' },
        { prop: 'percentageRate', value: '税率名称' },
        { prop: 'taxRateCode', value: '税率编码' },
    ],
    tableConfig: [
        { prop: 'taxRateCode', value: '税率编码' },
        { prop: 'percentageRate', value: '税率名称' },
    ],
    cbParams: ['percentageRate#taxRate'],
    advanceUrl: '/efTaxRate/popTaxRate/in',
}

// 结算客户
export const setcustomerAdvanceConfig = {
    name: '结算客户',
    value: 'ebcuNameCn',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' },
    ],
    tableConfig: [
        { prop: 'pmCode', value: '客户编码' },
        { prop: 'ebcuNameCn', value: '客户名称' },
    ],
    advanceUrl: 'ebCustomer/search',
    cbParams: ['pmCode', 'ebcuNameCn'],
}

// 发货仓库
export const cdWarehouseAdvanceConfig = {
    name: '发货仓库',
    value: 'bacSendName',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'cdwhName', value: '仓库名称' },
        { prop: 'whCode', value: '仓库编码' },
    ],
    tableConfig: [
        { prop: 'whCode', value: '仓库编码' },
        { prop: 'cdwhName', value: '仓库名称' },
    ],
    advanceUrl: 'cdWarehouse/search',
    cbParams: ['whCode', 'cdwhName'],
}

// 收货单位
export const ebShippersAdvanceConfig = {
    name: '收货单位',
    value: 'bacSendName',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'ebspNameCn', value: '收货单位名称' },
        { prop: 'ebspShipperNo', value: '收货单位代码' },
        { prop: 'ebspContact', value: '收货单位联系人' },
        { prop: 'ebspEblcAddress', value: '收货单位地址' },
    ],
    tableConfig: [
        { prop: 'ebspShipperNo', value: '收货单位代码' },
        { prop: 'ebspNameCn', value: '收货单位名称' },
        { prop: 'ebspContact', value: '收货单位联系人' },
        { prop: 'ebspEblcAddress', value: '收货单位地址' },
    ],
    advanceUrl: 'ebShippers',
    cbParams: ['ebspShipperNo', 'ebspNameCn', 'ebspContact', 'ebspEblcAddress'],
}

// 事故单-供应商
export const supplierAdvanceConfig = {
    name: '供应商',
    value: 'baSuppliersName',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'supplierNameCn', value: '供应商名称' },
        { prop: 'supplierCode', value: '供应商编码' },
    ],
    tableConfig: [
        { prop: 'supplierCode', value: '供应商编码' },
        { prop: 'supplierNameCn', value: '供应商名称' },
    ],
    advanceUrl: '/supplier/getSupplierInfoBySupplierInfoResponse',
    prefix: 'api-srm-web',
    cbParams: ['supplierCode#baSupplierCode', 'supplierNameCn#baSuppliersName'],
}

// 司机
export const driverAdvanceConfig = {
    name: '司机',
    value: 'baDriverName',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'driverName', value: '名称' },
        { prop: 'driverCode', value: '编号' },
        { prop: 'phoneNo', value: '手机号' },
        { prop: 'idCard', value: '身份证' },
    ],
    tableConfig: [
        { prop: 'driverCode', value: '编号' },
        { prop: 'driverName', value: '名称' },
        { prop: 'phoneNo', value: '手机号' },
        { prop: 'idCard', value: '身份证' },
    ],
    advanceUrl: '/supplier/supplierDriverInfos',
    prefix: 'api-srm-web',
    method: 'post',
    cbParams: ['driverCode#baDriverCode', 'driverName#baDriverName', 'phoneNo', 'idCard'],
}

// 发车信息
export const dispatchAdvanceConfig = {
    name: '发车信息',
    value: 'baCarcode',
    type: 'advance',
    unfold: true,
    advanceNotSearch: true,
    advanceConfig: [{ prop: 'dispatchNos', value: '发车单号' }],
    tableConfig: [
        { prop: 'dispatchNo', value: '发车单号' },
        { prop: 'dispatchTime', value: '发车时间' },
    ],
    advanceUrl: '/insurance/srmSearchDispatch',
    prefix: 'api-srm-web',
    method: 'post',
    multiple: true,
    multipleTableColumn: { prop: 'dispatchNo', value: '发车单号' },
    cbParams: [
        'dispatchNo#baCarcode',
        'dispatchTime#baCarcodeDate',
        'carrierCode#baSupplierCode',
        'carrierName#baSuppliersName',
        'driverNo#baDriverCode',
        'driver#baDriverName',
        'vehicleCard#licensePlateNo',
    ],
}

// 评估单号
export const assessAdvanceConfig = {
    name: '评估单号',
    value: 'baObjectCode',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'baCode', value: '评估单号' },
        { prop: 'baSupplersName', value: '保险公司名称' },
    ],
    tableConfig: [
        { prop: 'baCode', value: '评估单号' },
        { prop: 'baType', value: '评估类型', type: 'select', optionsKey: 'SRM_INSURANCE_BA_TYPE' },
        { prop: 'baSupplersName', value: '保险公司名称' },
    ],
    advanceUrl: '/insurance/insuranceBxAssessment/list',
    prefix: 'api-srm-web',
    method: 'post',
    cbParams: ['baCode#baObjectCode'],
}

// MIP账号
export const commonsAdvanceConfig = {
    name: 'MIP账号',
    value: 'ebcuNameCn',
    type: 'advance',
    unfold: true,
    advanceConfig: [
        { prop: 'queryParam', value: '名称' },
        { prop: 'queryParam', value: '账号' },
    ],
    tableConfig: [
        { prop: 'userCode', value: '账号' },
        { prop: 'userName', value: '名称' },
        { prop: 'email', value: '邮箱' },
    ],
    method: 'post',
    prefix: 'api-auth',
    advanceUrl: '/userInfo/queryCommons',
    cbParams: ['pmCode', 'ebcuNameCn'],
}

// 车型(MDM)
export const carTypeAdvanceConfig = {
    prop: 'lengthNameCn',
    label: '车型',
    value: 'lengthNameCn',
    type: 'advance',
    advanceConfig: [{ prop: 'actualVechile', value: '车型' }],
    prefix: 'api-andc',
    advanceUrl: '/cdTsEquipmentGroup/pageSearch',
    cbParams: ['cdegCode#length', 'actualVechile#lengthNameCn'],
    advanceCascade: { status: '0' },
    name: '车型',
    tableConfig: [
        { prop: 'actualVechile', value: '车型名称' },
        { prop: 'cdegCode', value: '车型编码' },
    ],
}

// 车型多选(MDM)
export const carTypeAdvanceMultiConfig = {
    prop: 'lengthNameCn',
    name: '车型',
    value: 'lengthNameCn',
    type: 'advance',
    unfold: true,
    searchRequired: true,
    advanceConfig: [
        { prop: 'actualVechile', value: '车型' },
        { prop: 'cdegCode', value: '车型编码' },
    ],
    prefix: 'api-andc',
    tableConfig: [
        { prop: 'actualVechile', value: '车型' },
        { prop: 'cdegCode', value: '车型编码' },
    ],
    advanceUrl: '/cdTsEquipmentGroup/pageSearch',
    cbParams: ['cdegCode#length', 'actualVechile#lengthNameCn'],
    span: 3,
    advanceCascade: { status: '0' },
    multiple: true,
    multipleDelConfirm: true,
    max: 10,
    multipleTableColumn: { prop: 'actualVechile', value: '车型' },
}

// 车型(SRM透传)
export const carTypeSrmAdvanceConfig = {
    prop: 'lengthNameCn',
    label: '车型',
    value: 'lengthNameCn',
    type: 'advance',
    advanceConfig: [{ prop: 'actualVechile', value: '车型' }],
    prefix: PFX,
    advanceUrl: '/supplier/dcApi/cdTsEquipmentGroupSearch',
    cbParams: ['cdegCode#length', 'actualVechile#lengthNameCn'],
    name: '车型',
    tableConfig: [
        { prop: 'actualVechile', value: '车型名称' },
        { prop: 'cdegCode', value: '车型编码' },
    ],
}

// 供应商
export const resourceSupAdvanceConfig = {
    name: '供应商名称',
    value: 'supplierName',
    type: 'advance',
    advanceConfig: [
        { prop: 'supplierName', value: '供应商名称' },
        { prop: 'supplierCode', value: '供应商编码' },
    ],
    tableConfig: [
        { prop: 'supplierCode', value: '供应商编码' },
        { prop: 'supplierName', value: '供应商名称' },
    ],
    advanceUrl: '/supplier/getSupplierInfoSimpleInfo',
    advanceCascade: 'propertyNature',
    cbParams: ['supplierCode', 'supplierName'],
    unfold: true,
    method: 'post',
    prefix: 'api-srm-web',
}

// 多规则计费模板
export const tempMoreRuleAdvanceConfig = {
    name: '计费模板',
    value: 'templateName',
    type: 'advance',
    advanceLabel: '计费模板弹出框',
    advanceConfig: [
        { prop: 'templateName', value: '模板名称' },
        { prop: 'templateCode', value: '模板编码' },
    ],
    moreSearchList: [
        {
            prop: 'templateName',
            label: '模板名称',
            type: 'input',
        },
        {
            prop: 'templateCode',
            label: '模板编码',
            type: 'input',
        },
        {
            prop: 'feeName',
            label: '费用名称',
            type: 'input',
        },
        {
            prop: 'calcRuleName',
            label: '计费规则名称',
            type: 'input',
        },
        {
            prop: 'collectUnitName',
            label: '汇总条件',
            type: 'input',
        },
        {
            prop: 'businessType',
            label: '业务类型',
            type: 'select',
            optionNum: 'SRM_BUSYNESS_TYPE_BACKGROUND',
        },
        {
            prop: 'orderTypeCode',
            label: '单据类型',
            type: 'select',
            optionArr: [],
        },
    ],
    tableConfig: [
        { prop: 'templateCode', value: '模板编码' },
        { prop: 'templateName', value: '模板名称' },
        { prop: 'feeName', value: '费用名称' },
        { prop: 'ruleName', value: '计费规则名称' },
        { prop: 'collectUnitName', value: '汇总条件' },
        { prop: 'orderTypeName', value: '单据类型' },
        { prop: 'businessTypeName', value: '业务类型' },
    ],
    advanceUrl: '/bid/calcTemplatePriceTypePage',
    prefix: '/api-srm-web',
    method: 'post',
    cbParams: ['templateName', 'templateNameArray', 'templateCode'],
    multiple: true,
    multipleTableColumn: { prop: 'templateName', value: '模板名称' },
    multipleDelConfirm: true,
    max: 15,
    // customClass: 'contract--more-rule-dialog',
    dialogWidth: '1200px',
}

// 合同
export const contractAdvanceConfig = {
    name: '合同编码',
    value: 'contractCode',
    type: 'advance',
    advanceConfig: [{ prop: 'contractCode', value: '合同编码' }],
    tableConfig: [
        { prop: 'contractCode', value: '合同编码' },
        { prop: 'contractName', value: '合同名称' },
    ],
    advanceUrl: '/contract/contractInfos',
    cbParams: ['contractCode', 'contractName'],
    method: 'post',
    prefix: 'api-srm-web',
}

// 合同(无权限过滤)
export const contractNoAuthConfig = {
    name: '合同名称',
    value: 'contractName',
    type: 'advance',
    advanceUrl: '/contract/queryContractInfoPageNotAuthFilter',
    cbParams: ['contractCode', 'contractName'],
    method: 'post',
    prefix: 'api-srm-web',
    advanceConfig: [
        { prop: 'contractCode', value: '合同编码' },
        { prop: 'contractName', value: '合同名称' },
        { prop: 'legalContractCode', value: '法务合同号' },
    ],
    tableConfig: [
        { prop: 'contractCode', value: '合同编码' },
        { prop: 'legalContractCode', value: '法务合同号' },
        { prop: 'contractName', value: '合同名称' },
    ],
}

// 指定客户
export const assignCustomerAdvanceConfig = {
    name: '指定客户',
    value: 'ebcuNameCn',
    type: 'advance',
    advanceLabel: '指定客户弹出框',
    advanceConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' },
    ],
    tableConfig: [
        { prop: 'pmCode', value: '客户编码' },
        { prop: 'ebcuNameCn', value: '客户名称' },
    ],
    advanceUrl: 'ebCustomer/searchByEbCustomer',
    cbParams: ['ebcuNameCn', 'pmCode'],
    // advanceCascade: 'companyCode#cdRunSiteCodes',
    multiple: true,
    multipleTableColumn: { prop: 'ebcuNameCn', value: '客户名称' },
}

// 订单客户
export const orderCustomerAdvanceConfig = {
    name: '订单客户',
    value: 'bpCustomerName',
    type: 'advance',
    advanceLabel: '订单客户弹出框',
    advanceConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' },
    ],
    tableConfig: [
        { prop: 'ebcuNameCn', value: '客户名称' },
        { prop: 'pmCode', value: '客户编码' },
    ],
    advanceUrl: '/ebCustomer/searchByEbCustomer',
    cbParams: ['pmCode#bpCustomerCode', 'ebcuNameCn#bpCustomerName'],
}

// dc-逻辑仓
export const logicalWhAdvanceConfig = {
    name: '逻辑仓',
    value: 'logicalWarehouseName',
    type: 'advance',
    advanceLabel: '逻辑仓',
    advanceConfig: [
        // { prop: 'ALL', value: '全部' },
        { prop: 'cdwhName', value: '逻辑仓名称' },
        { prop: 'whCode', value: '逻辑仓编码' },
    ],
    tableConfig: [
        { prop: 'whCode', value: '逻辑仓编码' },
        { prop: 'cdwhName', value: '逻辑仓名称' },
    ],
    advanceUrl: '/cdWarehouse/page',
    prefix: '/api-andc',
    method: 'post',
    cbParams: ['cdwhName#logicalWarehouseName', 'whCode#logicalWarehouseCode'],
}

// 经营中心
export const businessAdvanceConfig = {
    name: '经营中心',
    value: 'businessName',
    type: 'advance',
    advanceConfig: [
        { prop: 'escoCompanyNameCn', value: '经营中心名称' },
        { prop: 'escoCompanyNo', value: '经营中心编码' },
    ],
    tableConfig: [
        { prop: 'escoCompanyNo', value: '经营中心编码' },
        { prop: 'escoCompanyNameCn', value: '经营中心名称' },
    ],
    method: 'post',
    prefix: '/api-srm-web',
    advanceUrl: '/analysis/mdmService/pageSearchBusinessCenter',
    cbParams: ['escoCompanyNo#businessCode', 'escoCompanyNameCn#businessName'],
}
